/* eslint-disable react/no-array-index-key */
import {
    Heading, HStack, Skeleton, Text, VStack,
} from '@chakra-ui/react';
import { SkeletonMotion } from '@acp/core-ui';
import { CardLayout } from '../card-layout';
import { useGetStats } from '../../hooks/use-get-stats';
import { ServicesBreakdownModal } from './services-breakdown-modal';

function PropertiesStatsSkeleton() {
    return (
        <CardLayout px={{ base: 6, lg: 0 }} py={0}>
            <HStack
                w="full"
                gap={4}
                justifyContent="space-between"
                alignItems="stretch"
                flexWrap={{ base: 'wrap', md: 'nowrap' }}
            >
                {new Array(3).fill(0).map((_, idx) => (
                    <CardLayout key={idx} bgColor="white" elevated>
                        <VStack bg="white" w="full" alignItems="start">
                            <Skeleton h={5}>
                                Loading stat
                            </Skeleton>
                            <SkeletonMotion h={12} />
                        </VStack>
                    </CardLayout>
                ))}
            </HStack>
        </CardLayout>
    );
}

export function PropertiesStats() {
    const { isLoading, data } = useGetStats();

    if (isLoading || data === undefined) {
        return <PropertiesStatsSkeleton />;
    }

    const hasServicesBreakdown = !!((Boolean(data.portfolioStats.MANAGED_BY_DI))
        && Object.keys(data.portfolioStats.SERVICES_BREAKDOWN).length > 0);

    const propertyStatsData = [
        {
            name: 'Total properties under management',
            value: data.portfolioStats.TOTAL_PORTFOLIO,
        },
        {
            name: 'Properties on service with Detector Inspector',
            value: data.portfolioStats.MANAGED_BY_DI,
            hasServicesBreakdown,
        },
        {
            name: 'New properties under management',
            value: data.portfolioStats.NEW_MANAGEMENT,
        },
    ];

    return (
        <CardLayout px={{ base: 6, lg: 0 }} py={0}>
            <HStack
                w="full"
                h="full"
                gap={4}
                alignItems="stretch"
                flexWrap={{ base: 'wrap', md: 'nowrap' }}
            >
                {propertyStatsData.map((item) => (
                    <CardLayout key={item.name} bgColor="white" gap={0} flexGrow={1} justifyContent="space-between">
                        <HStack align="start">
                            <Text>{item.name}</Text>
                            {item.hasServicesBreakdown === true ? (
                                <ServicesBreakdownModal />
                            ) : null}
                        </HStack>
                        <Heading variant="circular" fontWeight="500" fontSize="xx-large">
                            {item.value.toLocaleString()}
                        </Heading>
                    </CardLayout>
                ))}
            </HStack>
        </CardLayout>
    );
}
